<script setup lang="ts">
import IconLogo from 'assets/logo-short.svg';
import IconLogoFB from 'assets/icons/fb.svg';
import IconLogoInstagram from 'assets/icons/instagram.svg';
import IconLogoLinkedin from 'assets/icons/linkedin.svg';

const { t } = useI18n();

const links = [
  { href: '/fixed-appliances', label: 'Devices' },
  { href: '/instructions', label: 'Instructions' },
  // { href: '/about-us', label: 'About_us' },
  { href: '/faq', label: 'FAQ' },
  // { href: '/imprint', label: 'Imprint' },
  { href: '/privacy-policy', label: 'Privacy_policy' },
  { href: '/terms-conditions', label: 'Terms_Conditions' },
];

const padding = useBigLayoutPadding();
</script>

<template>
  <footer>
    <div
      :style="{
        'padding-left': `${padding}px`,
        'padding-right': `${padding}px`,
      }"
      :class="['pt-[90px] max-md:pt-10']"
      class="bg-gray-900 w-full text-gray-100 whitespace-nowrap"
    >
      <div
        class=" w-full flex flex-col gap-8"
        :class="['pb-10 lg:pb-[112px]']"
      >
        <div
          class="w-full flex text-big"
          :class="['max-md:flex-col max-md:gap-10']"
        >
          <div
            class="flex flex-col gap-[34px]"
            :class="['md:w-1/2']"
          >
            <div class="text-h2 font-thicker w-full">
              {{ t('Contact_us').toUpperCase() }}
            </div>

            <div class="w-full flex flex-col gap-4 pr-2">
              <div>+371 23279911</div>
              <div>support@orthodgt.com</div>
              <div
                class="md:whitespace-break-spaces"
              >
                {{ t('Contact_address') }}
              </div>
              <div class="flex gap-2">
                <a
                  href="https://www.facebook.com/share/g/1A82smqEA6/?mibextid=wwXIfr"
                  target="_blank"
                >
                  <IconLogoFB class="w-6 h-6" />
                </a>
                <a
                  href="https://www.instagram.com/orthodgt?igsh=ZG1qdWJlMnhhbDgz"
                  target="_blank"
                >
                  <IconLogoInstagram class="w-6 h-6" />
                </a>
                <a
                  href="https://www.linkedin.com/company/orthodgt"
                  target="_blank"
                >
                  <IconLogoLinkedin class="w-6 h-6" />
                </a>
              </div>
            </div>
          </div>
          <div
            class="flex flex-col gap-8"
            :class="['md:w-1/2']"
          >
            <div class="w-full">
              <ButtonLevel href="/">
                <IconLogo class="w-[145px] h-[49px]" />
              </ButtonLevel>
            </div>
            <div class="w-full flex">
              <div class="w-full flex flex-col gap-4 items-start pr-2">
                <ButtonLevel
                  v-for="link in links.slice(0, 4)"
                  :key="link.label"
                  type="5"
                  :title="t(link.label).toUpperCase()"
                  :href="link.href"
                />
              </div>
              <div class="w-full flex flex-col gap-4 items-start pr-2">
                <ButtonLevel
                  v-for="link in links.slice(4)"
                  :key="link.label"
                  type="5"
                  :title="t(link.label).toUpperCase()"
                  :href="link.href"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="bg-gray-800 w-full h-[1px]" />
      <div class="text-small text-center pt-5 pb-8">
        {{ t('Copyright') }}
      </div>
    </div>
  </footer>
</template>

<style scoped>

</style>
